export class SparkJobStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<SparkJobStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<SparkJobStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SparkJobStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
